import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class RequestSltService extends Service{
    constructor() {
        super();
        this.baseURL = 'requestSlt';
    }

    findRequestSltsByRequestIdAndRequestType(requestType, requestId) {
        return fetch(SERVER_URL + this.baseURL+ '/findRequestSltsByRequestIdAndRequestType/' +requestType+ '/'+requestId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
    });
    }

    haveAnyRecord(requestId) {
        return fetch(SERVER_URL + this.baseURL+ '/haveAnyRecord/' +requestId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}